import { BLUE_GREY_200, GREEN_500 } from '@airtel/air-design-system';
export var serviceSelectionStepWidgetConfig = {
  state: 'none',
  isExpanded: true,
  autoFormSubmitDebounceDelay: 800,
  isAutoFormSubmitDebounceAllowed: false,
  stepDetailsProps: {
    title: 'STEP 1',
    heading: 'Select Service',
    avatarIcon: 'SimIcon',
    avatarProps: {
      style: {
        backgroundColor: BLUE_GREY_200
      }
    },
    actionType: 'button',
    actionTypeProps: {
      buttonText: 'Change'
    },
    actionTypePosition: 'center'
  },
  radioInputProps: {
    radioButtons: [{
      id: 'prepaid',
      label: 'Prepaid',
      value: 'prepaid',
      showAsCard: true,
      labelPosition: 'left',
      subRadioButtons: [{
        id: 'new-prepaid',
        label: 'New Prepaid',
        value: 'new-prepaid'
      }, {
        id: 'port-to-airtel-prepaid',
        label: 'Port to Airtel Prepaid',
        value: 'port-to-airtel-prepaid'
      }]
    }, {
      id: 'postpaid',
      label: 'Postpaid',
      value: 'postpaid',
      showAsCard: true,
      showInfoTagOnCard: true,
      infoTagProps: {
        text: 'No Data Limit',
        type: 'on-card',
        subType: 'new'
      },
      labelPosition: 'left',
      wrapperStyle: {
        marginLeft: 12
      },
      subRadioButtons: [{
        id: 'new-postpaid',
        label: 'New Postpaid',
        value: 'new-postpaid'
      }, {
        id: 'port-to-airtel-postpaid',
        label: 'Port to Airtel Postpaid',
        value: 'port-to-airtel-postpaid'
      }]
    }]
  },
  subRadioTitle: 'Select connection type',
  onMainRadioPressMetaData: {
    id: 'service-selection-step-widget',
    actions: []
  },
  onSubRadioPressMetaData: {
    id: 'connection-type-selection-step-widget',
    actions: []
  },
  onValidFormMetaData: {
    id: 'valid-form',
    actions: []
  }
};
export var successAvatarConfig = {
  avatarIcon: 'TickButtonIcon',
  avatarProps: {
    style: {
      backgroundColor: GREEN_500
    }
  }
};